import { combinedSearchGroups } from './combinedSearch';

export interface NotificationDraft {
  name: string;
  criteria: Record<string, string>;
}

const DAILY_NOTIFICATION_FILTERS = new Set([
  'title',
  'notice_id',
  'solicitation_number',
  'ptype',
  'naics_code',
  'classification_code',
  'set_aside',
  'state',
  'zip',
  'organization_code',
  'organization_name',
  'response_deadline_from',
  'response_deadline_to',
  'open_deadlines_only',
  'exclude_organization_name',
  'include_terms_any',
  'exclude_terms',
]);

function dailyCriteria(criteria: Record<string, string>): Record<string, string> {
  const result = Object.fromEntries(Object.entries(criteria).filter(([key, value]) => (
    DAILY_NOTIFICATION_FILTERS.has(key) && value.trim()
  )));
  if (criteria.any_of) {
    const groups = combinedSearchGroups(criteria.any_of);
    if (!groups.length) throw new Error('Unable to read the combined search filters.');
    result.any_of = JSON.stringify(groups.map((group) => ({
      name: group.name,
      criteria: dailyCriteria(group.criteria),
    })));
  }
  return result;
}

export function createNotificationDraft(
  sourceName: string,
  criteria: Record<string, string>,
): NotificationDraft {
  const notificationCriteria = dailyCriteria(criteria);
  const cleanName = sourceName.trim() || 'Search';
  return {
    name: `Daily: ${cleanName}`.slice(0, 100),
    criteria: notificationCriteria,
  };
}
